import {defaultConfiguration, defaultConfigurationGoogle, defaultConfigurationModules, IConfiguration} from "../configuration.state";
const CONFIGURATION_AUCHAN_RU: IConfiguration = {
  ...defaultConfiguration,
  api: {
    ...defaultConfiguration.api,
    protocol: 'https',
    port: '443'
  },
  theme: 'auchan',
  language: {
    defaultLang: 'ru',
    showLang: true,
    langList: ['en', 'ru', 'ro', 'ua']
  },
  pagesConfig: {
    ...defaultConfigurationModules,
    login: {
      ...defaultConfigurationModules.login,

      loginType: 'common',
      goFAQ: '',
      supportEmail: 'negoce_extranet@auchan.ru',
      enableSelfRegistration: false,
      enableGoogleSignIn: false,
      showTutorialVideo: false,
      showTryDemoButton: false,
      showAboutUsButton: false,
      showContacts: true,
      showContactOnlyEmail: true,

      contactsConfig: {
        showViber: false,
        showPhone: false,
        showEmail: true
      }
    },
    main: {
      showSupportBlock: false,
    },
    dataLedger: {
      ...defaultConfigurationModules.dataLedger,
      showSuppliersCodeForPartner: true
    }
  }
};


export const CONFIGURATION_AUCHAN_RU_ADMIN_INTERNAL:IConfiguration = {
  ...CONFIGURATION_AUCHAN_RU,
  api: {
    ...CONFIGURATION_AUCHAN_RU.api,
    protocol: 'http',
    port:'80'
  },
  auth:{
    realm: 'auchan_ru',
    module: 'ad'
  },
  pagesConfig:{
    ...defaultConfigurationModules,
    login:{
      ...defaultConfigurationModules.login,
      supportEmail: 'it@auchan.ru',
      enableRestorePassword: false,
      enableGoogleSignIn: true
    }
  },
  google: {
    ...defaultConfigurationGoogle,
    googleApiClientId: '796387608670-ffu9ptl7vfv2ohml5arjcfsic16pfs2k.apps.googleusercontent.com',
    googleApiScope: 'openid email', //profile openid email https://www.googleapis.com/auth/drive https://www.googleapis.com/auth/spreadsheets',
    googleApiDiscovery_docs: ["https://www.googleapis.com/discovery/v1/apis/drive/v3/rest", "https://sheets.googleapis.com/$discovery/rest"],
    GoogleApi_key: 'o6uOpx-rMEPfQw9xMcVyjPcF'
  }
};
export const CONFIGURATION_AUCHAN_RU_CLIENT_INTERNAL:IConfiguration = {
  ...CONFIGURATION_AUCHAN_RU,
  api: {
    ...CONFIGURATION_AUCHAN_RU.api,
    protocol: 'http',
    port:'8080'
  },
  auth:{
    realm: 'auchan_ru',
    module: 'ldap'
  }
};
export const CONFIGURATION_AUCHAN_RU_CLIENT_EXTERNAL:IConfiguration = {
  ...CONFIGURATION_AUCHAN_RU,
  api: {
    ...CONFIGURATION_AUCHAN_RU.api,
    protocol: 'https',
    port:'443'
  },
  auth:{
    realm: 'auchan_ru',
    module: 'ldap'
  }
};

export const CONFIGURATION_AUCHAN_RU_CLIENT_INTERNAL_WITH_DNS:IConfiguration = {
  ...CONFIGURATION_AUCHAN_RU_ADMIN_INTERNAL,
  api: {
    ...CONFIGURATION_AUCHAN_RU.api,
    protocol: 'http',
    port:'80'
  },
};
